import type { GotoPageInputProps } from '../types/components'
import { useEffect, useState } from 'react'


/** Go-to-page input — commits on Enter/blur, clamps to [1, totalPages] (Angular #gotoPage). */
export function GotoPageInput({ currentPage, totalPages, onGoto, testId }: GotoPageInputProps) {
  const [value, setValue] = useState(String(currentPage))

  useEffect(() => {
    setValue(String(currentPage))
  }, [currentPage])

  const commit = () => {
    const parsed = parseInt(value, 10)
    if (Number.isNaN(parsed)) {
      setValue(String(currentPage))
      return
    }
    const clamped = Math.min(Math.max(1, parsed), Math.max(1, totalPages))
    setValue(String(clamped))
    if (clamped !== currentPage) {
      onGoto(clamped)
    }
  }

  return (
    <input
      type="number"
      min={1}
      max={totalPages}
      value={value}
      onChange={(event) => setValue(event.target.value)}
      onBlur={commit}
      onKeyDown={(event) => {
        if (event.key === 'Enter') {
          event.preventDefault()
          commit()
        }
      }}
      className="w-14 rounded-lg border border-slate-200 bg-white px-1.5 py-1 text-sm text-slate-900 font-bold focus:border-button focus:outline-none focus:ring-2 focus:ring-button/30"
      data-testid={testId}
      aria-label="Go to page"
    />
  )
}
